import { PROJECTS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { addMockProject } from './mockProjects';
import { mockDelay, readMockProjectError } from './mockUtils';

export const PROJECT_VISIBILITIES = ['Private', 'Team', 'All'] as const;

export type ProjectVisibility = (typeof PROJECT_VISIBILITIES)[number];

/** Shape assumed until the backend contract exists */
export interface CreateProjectRequest {
  name: string;
  description: string | null;
  ownerId: string;
  teamId: string | null;
  visibility: ProjectVisibility;
  sharedWithUserIds: string[];
}

export interface CreateProjectResponse {
  projectId: string;
}

const MOCK_RESPONSE_DELAY_MS = 600;

const createProjectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createProject: builder.mutation<CreateProjectResponse, CreateProjectRequest>({
      // The backend `POST /projects` endpoint does not exist yet: the project joins the mock list (see mockProjects.ts).
      queryFn: async (request, { getState }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const mockError = readMockProjectError();
        if (mockError) return { error: mockError };
        return { data: addMockProject(request, getState()) };
      },
      invalidatesTags: (_result, error) => (error ? [] : [{ type: PROJECTS_LIST_TAG }]),
    }),
  }),
});

export const { useCreateProjectMutation } = createProjectApi;
